import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showModal } from '../../components/generic/Modal';
import { OrganizationChooserModal } from '../organization/OrganizationChooser';
import { AuthCard } from './components/AuthCard';
import { AuthLayout } from './components/AuthLayout';

export const MFAOrganizationError = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const organizationId = searchParams.get('organizationId') ?? '';
  const organizationName = searchParams.get('organizationName') ?? 'this organization';
  const returnPath = searchParams.get('return') ?? '/';

  const onEnrollMFA = React.useCallback(() => {
    const enrollURL = `/mfa/enrol?return=${encodeURIComponent(`/organizations/${organizationId}${returnPath !== '/' ? returnPath : ''}`)}`;
    void navigate(enrollURL);
  }, [navigate, organizationId, returnPath]);

  const onChooseDifferentOrganization = React.useCallback(() => {
    showModal(OrganizationChooserModal, {
      userHasMfa: false,
    });
  }, []);

  return (
    <AuthLayout>
      <AuthCard>
        <ChakraV3.Stack gap={6}>
          <ChakraV3.Stack gap={2}>
            <ChakraV3.Heading size='3xl' fontWeight='bold' color='gray.800'>
              2-Step Verification Required
            </ChakraV3.Heading>
            <ChakraV3.Text color='gray.600'>
              {organizationName} requires 2-Step Verification to access this organization.
            </ChakraV3.Text>
          </ChakraV3.Stack>

          <ChakraV3.Alert.Root status='info' variant='surface' rounded='md' alignItems='center'>
            <ChakraV3.Alert.Indicator />
            <ChakraV3.Text fontSize='sm'>
              You need to set up 2-Step Verification on your account before you can access this
              organization.
            </ChakraV3.Text>
          </ChakraV3.Alert.Root>

          <ChakraV3.Stack gap={3}>
            <ChakraV3.Button colorPalette='brand' size='lg' onClick={onEnrollMFA}>
              Enrol in 2-Step Verification
            </ChakraV3.Button>

            <ChakraV3.Button variant='outline' size='lg' onClick={onChooseDifferentOrganization}>
              Choose different organization
            </ChakraV3.Button>
          </ChakraV3.Stack>
        </ChakraV3.Stack>
      </AuthCard>
    </AuthLayout>
  );
};
